import styled from 'styled-components'

const TextContainer = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
TextContainer.displayName = 'TextContainer'
export default TextContainer
